<template>
  <!-- <a
    v-if="link || history"
    @click="goBack"
    class="float-left go-back d-inline-block position-relative"
  >
    <span class="icon-wrapper d-inline-block">
      <i class="material-icons-round">keyboard_arrow_left</i>
    </span>
    <label class="m-0 text-white">{{ name }}</label>
  </a>-->
  <div class="d-inline-block position-relative">
    <a @click="goPrev" class="go-back" v-if="prevLink">
      <svg-icon icon="arrow_w" />
    </a>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: null
    };
  },
  props: {
    name: {
      type: String,
      default: "Terug"
    },
    link: Object
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      // fetchData here
      // console.log(this.prevRoute);
      // alert(window.history.next);
      this.user = JSON.parse(localStorage.getItem("user"));
      // if (window.history.length > 2) {
      //   throw Error("SOMETHING IS WRONG WITH HISTORY");
      // }
    },
    goBack() {
      if (this.link) {
        this.$router.replace(this.link).catch(() => {});
      } else if (this.history) {
        let arr = this.$store.state.user_history;
        if (arr.length > 1) {
          arr.splice(-1, 1);
          let key = arr.length - 1;
          this.$router.replace(arr[key]).catch(() => {});
        } else {
          this.$router.replace(arr[0]).catch(() => {});
        }
      }
    },
    goPrev() {
      if (this.link) {
        this.$router.replace(this.link).catch(() => {});
      } else {
        this.$router.go(-1).catch(() => {});
      }
    },
    goNext() {
      this.$router.go(1).catch(() => {});
    },
    continue() {}
  },
  computed: {
    history: function() {
      if (this.$store.state.user_history.length) {
        if (this.$store.state.user_history.length == 1) {
          if (this.$store.state.user_history[0].path != this.$route.path) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    },
    prevLink: function() {
      // console.log(this.$store.state.previous_route.name);
      // console.log(window.history.length);
      if (this.$store.state.previous_route) {
        if (this.$store.state.previous_route.name) {
          return true;
        }
      } else if (window.history.length > 2) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
header .float-left {
  z-index: 1;
}
header a.go-back .icon-wrapper:last-child {
  margin: 0;
}
header a.go-back + a.go-back {
  padding-left: 10px;
}
</style>
